import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn"]

  resend() {
    this.btnTarget.disabled = true
    this.btnTarget.textContent = "Sending..."

    setTimeout(() => {
      this.btnTarget.textContent = "Email Sent!"
      setTimeout(() => {
        this.btnTarget.disabled = false
        this.btnTarget.textContent = "Resend confirmation email"
      }, 3000)
    }, 1000)
  }
}
